
import { RevLink } from '@ds/components/Link'
import { mapGetters } from 'vuex'

import { COUNTRIES } from '@config/constants'

import translations from './MusicalQuote.translations'

const COUNTRY_VIDEOS = {
  default: 'https://www.youtube.com/watch?v=t1TcDHrkQYg',
  [COUNTRIES.ES]: 'https://www.youtube.com/watch?v=62Z8vUIk9s8',
}

export default {
  components: {
    RevLink,
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      country: 'config/country',
    }),
    urlVideo() {
      return COUNTRY_VIDEOS[this.country] || COUNTRY_VIDEOS.default
    },
  },
}
